/* Novo Selo Winery — global behaviour (ported animations + header) */
(function () {
  // Scroll-reveal (safe: if anything fails, content simply stays visible)
  try {
    document.documentElement.classList.add('js-reveal');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.05, rootMargin: '0px 0px 15% 0px' });
    document.querySelectorAll('.reveal').forEach(function (el, i) {
      el.style.transitionDelay = (Math.min(i % 5, 4) * 60) + 'ms';
      io.observe(el);
    });
    setTimeout(function () {
      document.querySelectorAll('.reveal:not(.in)').forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) el.classList.add('in');
      });
    }, 1200);
  } catch (e) { document.documentElement.classList.remove('js-reveal'); }

  var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Lazy images fade in softly instead of popping into view
  if (!reducedMotion) {
    document.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
      if (img.complete) return;
      img.classList.add('img-wait');
      var done = function () { img.classList.remove('img-wait'); };
      img.addEventListener('load', done, { once: true });
      img.addEventListener('error', done, { once: true });
    });
  }

  // Hero day-to-night: --np goes 0 -> 1 as the hero scrolls away (and back on scroll up).
  // Phones get the plain video: the effect layers are hidden in CSS and the URL bar
  // makes vh jump around, so skip the scroll work entirely on touch/small screens.
  var heroFxOff = window.matchMedia('(pointer: coarse), (max-width: 760px)').matches;
  var hero = document.querySelector('.hero');
  if (hero && !reducedMotion && !heroFxOff) {
    var npTick = false;
    var npUpdate = function () {
      npTick = false;
      var h = hero.offsetHeight || 1;
      var y = window.scrollY || window.pageYOffset || 0;
      var p = Math.min(1, Math.max(0, y / (h * 0.9)));
      hero.style.setProperty('--np', p.toFixed(3));
    };
    window.addEventListener('scroll', function () {
      if (!npTick) { npTick = true; requestAnimationFrame(npUpdate); }
    }, { passive: true });
    window.addEventListener('resize', function () {
      if (!npTick) { npTick = true; requestAnimationFrame(npUpdate); }
    });
    npUpdate();
  }

  // Scroll-driven videos: footage advances as its section travels through the viewport
  var scrubVideos = Array.prototype.slice.call(document.querySelectorAll('video[data-scrub]'));
  if (scrubVideos.length && !reducedMotion) {
    var scrubState = scrubVideos.map(function (v) {
      v.pause();
      var pin = v.closest('.ib-pin-space');
      var st = { v: v, host: pin || v.parentElement, pin: !!pin, ready: v.readyState >= 1 };
      v.addEventListener('loadedmetadata', function () { st.ready = true; });
      return st;
    });
    (function scrubLoop() {
      var vh = window.innerHeight;
      scrubState.forEach(function (st) {
        var r = st.host.getBoundingClientRect();
        if (r.bottom < -100 || r.top > vh + 100) return;
        // pinned: play the full clip while the section stays stuck on screen
        var p = st.pin
          ? (-r.top) / (r.height - vh)
          : (vh - r.top) / (vh + r.height);
        p = Math.min(1, Math.max(0, p));
        if (st.ready && st.v.duration) {
          var want = p * st.v.duration * 0.98;
          var diff = want - st.v.currentTime;
          if (Math.abs(diff) > 0.02) st.v.currentTime = st.v.currentTime + diff * 0.16;
        }
      });
      requestAnimationFrame(scrubLoop);
    })();
  } else {
    scrubVideos.forEach(function (v) { v.pause(); }); // reduced motion: hold the poster frame
  }

  // Parallax backgrounds (Bononia-style): elements with data-parallax drift slower than the page
  var plxEls = document.querySelectorAll('[data-parallax]');
  if (plxEls.length && !reducedMotion) {
    var plxTick = false;
    var plxUpdate = function () {
      plxTick = false;
      var vh = window.innerHeight;
      plxEls.forEach(function (el) {
        var host = el.parentElement;
        var r = host.getBoundingClientRect();
        if (r.bottom < -80 || r.top > vh + 80) return;
        var speed = parseFloat(el.dataset.parallax) || 0.15;
        var shift = (r.top + r.height / 2 - vh / 2) * speed;
        el.style.transform = 'translateY(' + shift.toFixed(1) + 'px)';
      });
    };
    window.addEventListener('scroll', function () {
      if (!plxTick) { plxTick = true; requestAnimationFrame(plxUpdate); }
    }, { passive: true });
    plxUpdate();
  }

  // Stat numbers count up when they come into view (keeps prefix/suffix like "88 ha", "1,000+")
  try {
    var statEls = document.querySelectorAll('.stat-num');
    if (statEls.length && 'IntersectionObserver' in window && !reducedMotion) {
      var sio = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          sio.unobserve(e.target);
          var el = e.target;
          var raw = el.textContent.trim();
          var m = raw.match(/^([^0-9]*)([\d\s.,]+)(.*)$/);
          if (!m) return;
          var prefix = m[1], numStr = m[2], suffix = m[3];
          var trail = numStr.match(/\s+$/);
          if (trail) { suffix = trail[0] + suffix; numStr = numStr.replace(/\s+$/, ''); }
          var sep = numStr.indexOf(',') > -1 ? ',' : (/\d\s\d/.test(numStr) ? ' ' : '');
          var target = parseInt(numStr.replace(/[^\d]/g, ''), 10);
          if (!target || target > 999999) return;
          var fmt = function (n) {
            var s = String(Math.round(n));
            return sep ? s.replace(/\B(?=(\d{3})+(?!\d))/g, sep) : s;
          };
          var dur = 1400, start = null;
          var step = function (ts) {
            if (!start) start = ts;
            var t = Math.min(1, (ts - start) / dur);
            var v = target * (1 - Math.pow(1 - t, 3));
            el.textContent = prefix + fmt(v) + suffix;
            if (t < 1) requestAnimationFrame(step);
            else el.textContent = raw;
          };
          requestAnimationFrame(step);
        });
      }, { threshold: 0.4 });
      statEls.forEach(function (el) { sio.observe(el); });
    }
  } catch (e) { /* counters are decorative */ }

  // Mobile menu toggle
  var toggle = document.querySelector('.menu-toggle');
  var nav = document.querySelector('.mobile-nav');
  if (toggle && nav) {
    function closeNav() {
      nav.classList.remove('open');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }
    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.style.overflow = open ? 'hidden' : '';
    });
    var mx = nav.querySelector('.mnav-x');
    if (mx) mx.addEventListener('click', closeNav);
    nav.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', closeNav);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && nav.classList.contains('open')) closeNav();
    });
  }
})();
